import { render } from "./UsersSettingView.vue?vue&type=template&id=959535ae&scoped=true"
import script from "./UsersSettingView.vue?vue&type=script&lang=js"
export * from "./UsersSettingView.vue?vue&type=script&lang=js"

import "./UsersSettingView.vue?vue&type=style&index=0&id=959535ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-959535ae"]])

export default __exports__